import { render, staticRenderFns } from "./FaleConosco.vue?vue&type=template&id=35c92abe&scoped=true&lang=pug"
import script from "./FaleConosco.vue?vue&type=script&lang=js"
export * from "./FaleConosco.vue?vue&type=script&lang=js"
import style0 from "./FaleConosco.styl?vue&type=style&index=0&id=35c92abe&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c92abe",
  null
  
)

export default component.exports